import $ from 'jquery';
import 'sharer.js';
import 'accordionjs';
import { OverlayScrollbars } from 'overlayscrollbars';
import { accordionPopup } from './global-variables';

// eslint-disable-next-line no-undef
const ajaxObject = agObject;

$(document).ready(function ($) {
    $('.ag-accordion').accordionjs({
        closeAble: true,
    });
});

$('.accordion-popup-opener').on('click', (e) => {
    const button = $(e.target);
    const id = button.data('id');

    $.ajax({
        url: ajaxObject.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
            nonce: ajaxObject.nonce,
            action: 'arc_gestion_do_accordion_popup',
            id,
        },
        beforeSend: () => {
            $('.ag-acc-popup').remove();
            $('body').append(accordionPopup);
            $('body').addClass('modal-active');
        },
        success: (response) => {
            $('.ag-acc-popup .ag-spinner').hide();
            $('.ag-acc-popup .ag-modal-content').html(response.data.content);
            OverlayScrollbars($('.ag-acc-popup')[0], {
                className: 'os-theme-thin-light',
            });
        },
    });
});
